import { useTranslation } from 'react-i18next'

type Options = {
  yearFormat: 'YYYY' | 'YY'
}

export const dateFormatForLanguage = (language: string, options?: Options) => {
  const yearFormat = options?.yearFormat || 'YYYY'

  const dateFormat = language.toLowerCase().includes('us') ? 'MM/DD' : 'DD/MM'

  return `${dateFormat}/${yearFormat}`
}

const useDateDisplayFormat = (options?: Options) => {
  const [, { resolvedLanguage }] = useTranslation()

  return dateFormatForLanguage(resolvedLanguage, options)
}

export default useDateDisplayFormat
